import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { DefaultAndSpaceClassificationLevelsQuery } from '../queries/DefaultAndSpaceClassificationQuery.graphql';

export function preloadDefaultAndSpaceClassificationLevels(spaceKey: string = '') {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: DefaultAndSpaceClassificationLevelsQuery,
		variables: {
			spaceKey,
		},
	});
}
